import React, { useState } from 'react';

const tips = [
  {
    title: 'People around you',
    desc: 'Each avatar on the map is a real person nearby. Colors indicate gender. A green dot means they\'re online now.',
    svg: <svg width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="18" fill="rgba(135,206,235,0.1)" stroke="#87CEEB" strokeWidth="1.5"/><circle cx="20" cy="16" r="6" stroke="#87CEEB" strokeWidth="1.5"/><path d="M8 34C8 27.4 13.4 22 20 22C26.6 22 32 27.4 32 34" stroke="#87CEEB" strokeWidth="1.5" strokeLinecap="round"/><circle cx="32" cy="12" r="5" fill="rgba(0,214,143,0.2)" stroke="#00d68f" strokeWidth="1.2"/><circle cx="32" cy="12" r="2" fill="#00d68f"/></svg>
  },
  {
    title: 'Tap to message',
    desc: 'Tap any profile on the map to see their details. Hit "Message" to start a conversation instantly — no match needed.',
    svg: <svg width="40" height="40" viewBox="0 0 40 40" fill="none"><rect x="4" y="8" width="32" height="22" rx="6" fill="rgba(255,182,193,0.1)" stroke="#FFB6C1" strokeWidth="1.5"/><path d="M4 22L12 28L20 22" stroke="#FFB6C1" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="14" cy="19" r="2" fill="#FFB6C1" opacity="0.8"/><circle cx="20" cy="19" r="2" fill="#FFB6C1" opacity="0.8"/><circle cx="26" cy="19" r="2" fill="#FFB6C1" opacity="0.8"/></svg>
  },
  {
    title: 'Stay safe',
    desc: 'Your exact location is never shown — positions are randomized by ±1km. You can hide yourself at any time.',
    svg: <svg width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M20 4L34 10V22C34 29.7 27.7 36.4 20 38C12.3 36.4 6 29.7 6 22V10L20 4Z" fill="rgba(0,214,143,0.08)" stroke="#00d68f" strokeWidth="1.5" strokeLinejoin="round"/><path d="M14 20L18 24L26 16" stroke="#00d68f" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
  },
];

export default function Onboarding({ onDone }) {
  const [step, setStep] = useState(0);

  const next = () => {
    if (step < tips.length - 1) setStep(step + 1);
    else onDone();
  };

  const tip = tips[step];

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.92)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:'20px' }}>
      <div style={{ background:'#111', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'24px', padding:'32px 28px', maxWidth:'360px', width:'100%', textAlign:'center', animation:'slideUp 0.3s ease' }}>

        {/* Étapes */}
        <div style={{ display:'flex', gap:'6px', justifyContent:'center', marginBottom:'28px' }}>
          {tips.map((_, i) => (
            <div key={i} style={{ height:'3px', borderRadius:'100px', background: i <= step ? 'white' : 'rgba(255,255,255,0.12)', flex:1, transition:'background 0.3s' }}/>
          ))}
        </div>

        {/* Icône */}
        <div style={{ display:'flex', justifyContent:'center', marginBottom:'20px' }}>
          {tip.svg}
        </div>

        <h3 style={{ color:'white', fontWeight:700, fontSize:'1.1rem', marginBottom:'10px', letterSpacing:'-0.3px' }}>{tip.title}</h3>
        <p style={{ color:'rgba(255,255,255,0.4)', fontSize:'0.88rem', lineHeight:1.7, marginBottom:'28px' }}>{tip.desc}</p>

        <button onClick={next} style={{ width:'100%', padding:'14px', background:'white', color:'#080808', border:'none', borderRadius:'13px', fontWeight:700, fontSize:'0.95rem', cursor:'pointer' }}>
          {step < tips.length - 1 ? 'Next' : 'Start exploring'}
        </button>

        {step < tips.length - 1 && (
          <button onClick={onDone} style={{ width:'100%', marginTop:'8px', padding:'10px', background:'transparent', border:'none', color:'rgba(255,255,255,0.2)', fontSize:'0.82rem', cursor:'pointer' }}>
            Skip
          </button>
        )}
      </div>
    </div>
  );
}
